import { render, staticRenderFns } from "./BaseFormFileInput.vue?vue&type=template&id=51e253c2&"
import script from "./BaseFormFileInput.vue?vue&type=script&lang=ts&"
export * from "./BaseFormFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFormFileInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports